import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import type { BadgeView } from '@app/helpers/status.helper';
import { connectionToStatus, statusBadge } from '@app/helpers/status.helper';
import { RowStatus } from '@app/models/status.model';
import { TranslateModule } from '@ngx-translate/core';
import type { ICellRendererParams } from 'ag-grid-community';

export type BadgeCellRendererParams = ICellRendererParams & {
  view?: BadgeView;
};

@Component({
  selector: 'app-badge-cell-renderer',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './badge-cell-renderer.component.html',
  styleUrl: './badge-cell-renderer.component.scss',
})
export class BadgeCellRendererComponent {
  view: BadgeView = { ...statusBadge.toView('pending') };

  agInit(params: ICellRendererParams): void {
    const param = params as BadgeCellRendererParams;

    if (param.view) {
      this.view = param.view;
      return;
    }

    const raw = (params.data as any)?.status;
    const status: RowStatus = connectionToStatus(raw) ? raw : 'pending';
    this.view = statusBadge.toView(status);
  }

  refresh(): boolean {
    return false;
  }
}
